import React from 'react'
import { Grid } from '@mui/material'
import RunningScrapersTable from './Table'
import ScraperUserSearchesModal from './ScraperUserSearchesModal'
import { tabSelected } from '../@signals'
import { GLOBAL_EXECUTION_TABS } from '../@constants'


export default function GlobalExecutionScrapersBlock() {

    if(tabSelected.value !== GLOBAL_EXECUTION_TABS.SCRAPERS) return null

    return <>
        <Grid item xs={12}>
            <RunningScrapersTable/>
        </Grid>
        <ScraperUserSearchesModal />
    </>
}